<template>
  <section>
    <resource
      title="Ändern"
      resource="giftCategory"
      resourceName="Geschenkkategorie"
      :original="original"
      :attributes="[
        {
          name: 'name',
          label: 'Name'
        },
        {
          name: 'active',
          label: 'Aktiv',
          type: 'CheckboxSelector'
        }
      ]"
    >
      <div slot="title">
        <h4>Geschenkkategorie bearbeiten</h4>
      </div>
    </resource>
  </section>
</template>

<script lang="babel">
import store from "@/store";

export default {
  beforeRouteEnter (to, from, next) {
    store.dispatch('giftCategory/read', [
      {
        name: 'where',
        attributes: {
          id : [Number(to.params.id)],
        }
      },
    ]).then(() => {
      next();
    });
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    original() {
      return this.$store.getters['giftCategory/find'](this.id);
    }
  }
}
</script>
